import './registrer.css';
import '../footer/about.css';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SocialLoginRegistrer from './coursesandgamespage/SocialLoginRegistrer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faUser, faEnvelope, faLock, faCheckCircle, faTimesCircle, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export const Registrer = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [repeatpass, setRepeatpass] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({ score: 0, text: '', color: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  // Adaugă URL-ul API-ului folosind variabila de mediu
  const apiUrl = process.env.REACT_APP_API_URL;

  const calculatePasswordStrength = (pass) => {
    let score = 0;
    if (pass.length >= 8) score++;
    if (/[A-Z]/.test(pass)) score++;
    if (/[a-z]/.test(pass)) score++;
    if (/[0-9]/.test(pass)) score++;
    if (/[!@#$%^&*(),.?":{}|<>]/.test(pass)) score++;
    
    if (score <= 2) return { score, text: 'Slabă', color: '#ff4444' };
    if (score === 3) return { score, text: 'Medie', color: '#ffaa00' };
    if (score === 4) return { score, text: 'Bună', color: '#00cc88' };
    return { score, text: 'Excelentă', color: '#00aa44' };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const validatePassword = (password) => {
      const minLength = 8;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumber = /[0-9]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

      if (password.length < minLength) return 'Parola trebuie să aibă cel puțin 8 caractere';
      if (!hasUpperCase) return 'Parola trebuie să conțină cel puțin o literă mare';
      if (!hasLowerCase) return 'Parola trebuie să conțină cel puțin o literă mică';
      if (!hasNumber) return 'Parola trebuie să conțină cel puțin un număr';
      if (!hasSpecialChar) return 'Parola trebuie să conțină cel puțin un caracter special';
      return '';
    };

    if (!validateEmail(email)) {
      setErrorMessage('Adresa de email este invalidă');
      setIsLoading(false);
      return;
    }

    const passwordError = validatePassword(password);
    if (passwordError) {
      setErrorMessage(passwordError);
      setIsLoading(false);
      return;
    }

    if (password !== repeatpass) {
      setErrorMessage('Parolele nu se potrivesc');
      setIsLoading(false);
      return;
    }

    const userData = {
      username,
      email,
      password,
    };

    console.log('Attempting registration with:', { username, email, apiUrl: `${apiUrl}/accounts` });

    fetch(`${apiUrl}/accounts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
      credentials: 'include',
    })
      .then((response) => {
        console.log('Response status:', response.status);
        if (!response.ok) {
          return response.json()
            .then((errorData) => {
              console.error('Error response:', errorData);
              // Mesaje personalizate pentru diferite statusuri
              if (response.status === 409) {
                throw new Error('Există deja un cont cu această adresă de email. Te rugăm să te autentifici sau să folosești alt email.');
              }
              throw new Error(errorData.message || 'A apărut o eroare la crearea contului');
            })
            .catch((jsonError) => {
              // Dacă nu e JSON valid sau altă eroare
              if (jsonError.message.includes('Există deja')) {
                throw jsonError; // Propagă mesajul nostru custom
              }
              if (response.status === 409) {
                throw new Error('Există deja un cont cu această adresă de email.');
              }
              throw new Error(`Eroare la crearea contului. Te rugăm să încerci din nou.`);
            });
        }
        return response.json();
      })
      .then((data) => {
        console.log('Registration successful:', data);
        setUsername('');
        setEmail('');
        setPassword('');
        setRepeatpass('');
        setPasswordStrength({ score: 0, text: '', color: '' });
        
        // Mesaj care anunță utilizatorul să-și verifice e-mailul pentru confirmare
        setSuccessMessage('Contul a fost creat cu succes! Te rugăm să îți verifici adresa de e-mail pentru a confirma contul.');
        setErrorMessage('');
      })
      .catch((error) => {
        console.error('Registration error:', error);
        setErrorMessage(error.message || 'A apărut o eroare. Te rugăm să încerci din nou.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className='general-container-footer-info-ab'>
      <div className='info-footer-container-ab'>
        <section className='section-about-1'>
          <div>
            <h3 className='align-about-ab'>
              <span className='acasa-about-footer'>Acasa</span>
              <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
              <span className='color-despre'>Creeaza cont</span>
            </h3>
          </div>
        </section>

        <div className='registrer-wrapper'>
          <form className="registrer-form mt-4" onSubmit={handleSubmit}>
        <h2 className='registrer-title fs-1'>Creeaza cont!</h2>
        
        <div className="input-group-reg">
          <FontAwesomeIcon icon={faUser} className="input-icon-reg" />
          <input
            type="text"
            id="username"
            name="username"
            className="input-reg with-icon"
            placeholder="Nume si prenume"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="input-group-reg">
          <FontAwesomeIcon icon={faEnvelope} className="input-icon-reg" />
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            className="input-reg with-icon"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="input-group-reg" style={{ position: 'relative' }}>
          <FontAwesomeIcon icon={faLock} className="input-icon-reg" />
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            value={password}
            className="input-reg with-icon"
            placeholder="Parola"
            style={{ paddingRight: '45px' }}
            onChange={(e) => {
              setPassword(e.target.value);
              if (e.target.value) {
                setPasswordStrength(calculatePasswordStrength(e.target.value));
              } else {
                setPasswordStrength({ score: 0, text: '', color: '' });
              }
            }}
            required
          />
          <FontAwesomeIcon
            icon={showPassword ? faEyeSlash : faEye}
            className="toggle-password-icon-reg"
            onClick={() => setShowPassword(!showPassword)}
          />
        </div>

        {password && (
          <div className="password-strength-indicator">
            <div className="strength-bar">
              <div 
                className="strength-fill" 
                style={{ 
                  width: `${(passwordStrength.score / 5) * 100}%`,
                  backgroundColor: passwordStrength.color 
                }}
              />
            </div>
            <span className="strength-text" style={{ color: passwordStrength.color }}>
              Putere parolă: {passwordStrength.text}
            </span>
          </div>
        )}

        <div className="input-group-reg" style={{ position: 'relative' }}>
          <FontAwesomeIcon icon={faLock} className="input-icon-reg" />
          <input
            type={showRepeatPassword ? "text" : "password"}
            id="repeatpass"
            name="repeatpass"
            value={repeatpass}
            className="input-reg with-icon"
            placeholder="Reintrodu parola"
            style={{ paddingRight: '45px' }}
            onChange={(e) => setRepeatpass(e.target.value)}
            required
          />
          <FontAwesomeIcon
            icon={showRepeatPassword ? faEyeSlash : faEye}
            className="toggle-password-icon-reg"
            onClick={() => setShowRepeatPassword(!showRepeatPassword)}
          />
        </div>
        {errorMessage && (
          <div className="message-box error-message-box">
            <FontAwesomeIcon icon={faTimesCircle} className="message-icon" />
            {errorMessage}
          </div>
        )}
        
        {successMessage && (
          <div className="message-box success-message-box">
            <FontAwesomeIcon icon={faCheckCircle} className="message-icon" />
            {successMessage}
          </div>
        )}

        <button type="submit" className="input-reg-submit" disabled={isLoading}>
          {isLoading ? 'Se înregistreaza...' : 'Creeaza cont'}
        </button>
      </form>

      <div className='divider-sau'>
        <span>SAU</span>
      </div>
      
      <div className='options-connect-registrer'>
        <SocialLoginRegistrer />
      </div>

      <div className='redirect-registrer'>
        <span className='redirect-reg-text'>Ai deja cont?</span>
        <Link to='/login' className='redirect-reg-link'>
          <b>Logheaza-te!</b>
        </Link>
      </div>

      <div className='redirect-registrer'>
        <span className='redirect-reg-text-terms'>Prin inregistrare, sunteti de acord cu
        <Link to='/Termeni' className='redirect-reg-terms'>
          <span> termenii si conditiile de utilizare</span>
        </Link>
        </span>
      </div>
        </div>
      </div>
    </div>
  );
};
